var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pe-empty-comp"},[_c('img',{attrs:{"src":require("../assets/img_pe_empty@2x.png")}}),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.tip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }